<template>
    <!-- modal-xl -->
    <b-modal id="certificateMatchListModal" size="xl" title="Certificate Match List Modal" title-class="font-18" hide-footer>
        <!-- <h5>List of Cetificates for Bob's Bolts</h5> -->
        <div v-if="hasMounted && result_of_searched_certificates">
            <webix-ui :config="ui" v-model="result_of_searched_certificates"></webix-ui>
            <div id="certificateMatchListModalPaging"></div>
        </div>

        <div class="modal-footer mt-3 d-flex justify-content-between">
            <button type="button" class="btn btn-primary" @click="handleModal('certificateAddModal')">
                Add New Certificate
            </button>
            <button type="button" class="btn btn-primary" @click="closeModal">
                Close
            </button>
        </div>
    </b-modal>
</template>

<script>
import { suppliersComputed, suppliersMethods } from "../../state/helpers";

export default {
    data: () => ({
        hasMounted: false,
    }),

    computed: {
        ...suppliersComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            //eslint-disable-next-line
            let ui = {
                id: "certificateMatchListModalTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border",
                autoheight: true,
                //hover: "datatableHover",
                minHeight: 60,
                minColumnWidth: 120,
                rowHeight: 40,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                // select: false,
                // select: true,
                // pager: {
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "certificateMatchListModalPaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "actions",
                        header: [{ text: "Actions", css: { "text-align": "center" } }],
                        fillspace: 0.5,
                        template: function() {
                            return `
                        <div class="tableIcons">
                            <i class="mdi mdi-eye viewAction"></i>
                        </div>`;
                        },
                    },
                    {
                        id: "company_name",
                        header: ["Name", { content: "textFilter" }],
                        tooltip: false,
                        width: 200,
                        template: function(obj) {
                            obj.company_name;
                            return "<div class='matchListPointer  viewAction'>" + obj.company_name + " </div>";
                        },
                    },
                    {
                        id: "document_type",
                        header: ["Document Type", { content: "selectFilter" }],
                        tooltip: false,
                        fillspace: 0.8,
                    },
                    {
                        id: "issue_date",
                        header: ["Issue Date", { content: "textFilter" }],
                        fillspace: 0.8,
                        template: function(obj) {
                            return obj.issue_date.substring(0, 10);
                        },
                    },
                    {
                        id: "expiry_date",
                        header: ["Expiry Date", { content: "textFilter" }],
                        fillspace: 0.8,
                        template: function(obj) {
                            return obj.expiry_date.substring(0, 10);
                        },
                    },
                    {
                        id: "vetting_status",
                        header: ["Vetting Status", { content: "textFilter" }],
                        fillspace: 0.8,
                        template: function(obj) {
                            if (obj.document_type == "Certificate") {
                                //eslint-disable-next-line
                                if (obj.authentication_status == null) {
                                    return "Not Authenticated";
                                }
                                return obj.authentication_status;
                            }

                            if (obj.document_type == "Affidavit") {
                                //eslint-disable-next-line
                                if (obj.vetting_status == null) {
                                    return "Not Vetted";
                                }
                                return obj.vetting_status;
                            }

                            return obj.vetting_status;
                        },
                    },
                    {
                        id: "bbbee_level",
                        header: ["BEE Level", { content: "textFilter" }],
                        fillspace: 1,
                    },
                ],
                on: {
                    // onBeforeSelect: function() {
                    //     let el = this.$scope.$parent.$parent.$parent;
                    //     el.handleModal("certificateCheckModal");
                    // },
                },
                onClick: {
                    //eslint-disable-next-line
                    viewAction: function(id, e, trg) {
                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent.$parent;
                        //eslint-disable-next-line
                        let row = this.getItem(e.row);

                        //eslint-disable-next-line
                        console.log("the row", row);

                        el.setSelectedSearchedCertificate(row);
                        el.handleModal("certificateCheckModal");
                    },
                },
            };

            //pager
            if (this.result_of_searched_certificates.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "certificateMatchListModalPaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                };
            }

            return ui;
        },
    },
    watch: {
        hasMounted() {
            setTimeout(() => {
                this.$nextTick(() => {
                    window.webix.$$("certificateMatchListModalTable").refresh();
                });
            }, 5);
        },
    },
    methods: {
        ...suppliersMethods,
        handleModal(modalName) {
            if (modalName == "certificateAddModal") {
                this.closeModal();
            }
            this.$emit("handleModal", modalName);
        },
        closeModal() {
            this.$bvModal.hide("certificateMatchListModal");
        },
    },
    mounted() {
        this.hasMounted = true;
        window.certificatesTable = this;
    },
};
</script>

<style lang="scss">
.matchListPointer {
    cursor: pointer;
}
.handle-overflow {
    overflow: scroll;
}
</style>
